export default __webpack_public_path__ + "static/media/orange.8fa56f81.svg";